import React, { memo } from 'react';

import { Progress } from 'antd';
import styled from 'styled-components';

import fontService, { FontWeight, TextType } from 'services/FontService';
import { Colors } from 'context';

export interface IProfileCompletenessBar {
  percent: number;
  title: string;
  hint?: string;
}

/**
 * Profile completeness meter (spec 0018 §3.2 — `completeness(profile)`), with an
 * optional nudge ("add projects") shown while the score is low.
 */
export const ProfileCompletenessBar = memo(({ percent, title, hint }: IProfileCompletenessBar) => (
  <Wrapper>
    <Row>
      <Label>{title}</Label>
      <Value>{percent}%</Value>
    </Row>
    <Progress percent={percent} showInfo={false} strokeColor={Colors.main} />
    {hint ? <Hint>{hint}</Hint> : null}
  </Wrapper>
));

const Wrapper = styled.div`
  width: 100%;
`;

const Row = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  margin-bottom: 4px;
`;

const Label = styled.span`
  ${fontService.text({ size: 14, lineHeight: 145, weight: FontWeight.medium })}
`;

const Value = styled.span`
  ${fontService.text({ size: 14, lineHeight: 145, weight: FontWeight.bold })}
`;

const Hint = styled.p`
  margin: 8px 0 0;
  color: ${Colors.gray_dark};
  ${fontService.text({ type: TextType.small, weight: FontWeight.regular })}
`;
